import React, {useEffect, useState} from "react";
import FJPreviewTips from "../view/FJPreviewTips";
import FJEventConstant from "../../../constant/FJEventConstant";

function FJPreviewTipContainer() {

  const [pos, updatePos] = useState({left: 0, top: 0});
  const [active, updateActive] = useState(false);
  const [angle, updateAngle] = useState(0);

  useEffect(() => {
    return window.FJEvent.subscribe(FJEventConstant.GRAPH_ROTATE, ({pos, angle}) => {
      let _angle = Math.round(angle > 180 ? angle - 360 : angle);
      updateActive(true);
      updatePos({left: pos.x, top: pos.y, transform: `translate(26px, 6px)`});
      updateAngle(`${_angle}°`);
    });
  }, []);

  useEffect(() => {
    return window.FJEvent.subscribe(FJEventConstant.GRAPH_ROTATED, () => {
      updateActive(false);
    });
  }, []);

  return (
    <FJPreviewTips active={active} point={pos} text={angle} />
  );
}

export default FJPreviewTipContainer;